import { RESET_FORM_FIELDS} from "../formReset/types";

// src/store/formReset/actions.js
export const resetFormFields = () => ({
  type: RESET_FORM_FIELDS,
});
